<template>
  <button title="Show Password" type="button" class="VuePassword__Toggle" @click="toggleInputType">

    <template v-if="toggle === true">
      <font-awesome-icon size="lg" icon="eye"/>
    </template>
    <template v-else>
      <font-awesome-icon size="lg" icon="eye-slash"/>
    </template>

  </button>
</template>

<script>
  export default {
    name: 'password-toggle',
    props: {
      input: Object
    },
    computed: {
      toggle() {
        return this.input && this.input.type === 'password';
      }
    },
    methods: {
      toggleInputType() {
        this.input && this.input.type === 'password' ? this.input.type = 'text' : this.input.type = 'password';
      }
    }
  };
</script>

<style scoped>
.VuePassword__Toggle {
  margin-right: 22.75px;
  position: absolute;
  right: 8px;
  top: 32px;
  height: 25px;
  background: transparent;
  border: none;
  opacity: 0.65;
}
</style>
